import { stepConfigItem } from './types';
import { DietIdEnum } from '@front-activerse/common-components';

const stepsSchemaPl: stepConfigItem[] = [
  { id: 'sex', slug: 'sex' },
  { id: 'dateOfBirth', slug: 'birth-date', shouldBackendValidate: true },
  { id: 'heightValue', slug: 'height', shouldBackendValidate: true },
  {
    id: 'weightValue',
    slug: 'weight',
    shouldBackendValidate: true,
  },
  {
    id: 'dietMode',
    slug: 'diet-mode',
    fork: {
      chooseChild: (state: { dietMode: string }) =>
        state.dietMode !== 'stabilization' ? 'goalWeight' : 'activityLevel',
      children: {
        goalWeight: [
          { id: 'goalWeightValue', slug: 'goal-weight', shouldBackendValidate: true },
          { id: 'spontaneousActivityLevel', slug: 'spontaneous-activity-level' },
          { id: 'activityLevel', slug: 'activity-level' },
          {
            id: 'dietType',
            slug: 'diet-type',
            fork: {
              chooseChild: (state: { dietType: any }) =>
                state.dietType === DietIdEnum.DIET_ID_CLASSIC ||
                state.dietType === DietIdEnum.DIET_ID_CLASSIC_LVL2 ||
                state.dietType === DietIdEnum.DIET_ID_CLASSIC_LVL3
                  ? 'withDietLevel'
                  : 'normal',
              children: {
                withDietLevel: [
                  {
                    id: 'dietLevel',
                    slug: 'diet-level',
                  },
                  { id: 'summary', slug: 'summary' },
                ],
                normal: [{ id: 'summary', slug: 'summary' }],
              },
            },
          },
        ],
        activityLevel: [
          { id: 'spontaneousActivityLevel', slug: 'spontaneous-activity-level' },
          { id: 'activityLevel', slug: 'activity-level' },
          {
            id: 'dietType',
            slug: 'diet-type',
            fork: {
              chooseChild: (state: { dietType: any }) =>
                state.dietType === DietIdEnum.DIET_ID_CLASSIC ||
                state.dietType === DietIdEnum.DIET_ID_CLASSIC_LVL2 ||
                state.dietType === DietIdEnum.DIET_ID_CLASSIC_LVL3
                  ? 'withDietLevel'
                  : 'normal',
              children: {
                withDietLevel: [
                  {
                    id: 'dietLevel',
                    slug: 'diet-level',
                  },
                  { id: 'summary', slug: 'summary' },
                ],
                normal: [{ id: 'summary', slug: 'summary' }],
              },
            },
          },
        ],
      },
    },
  },
];

export default stepsSchemaPl;
